/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TextMessage
 */
export interface TextMessage {
    /**
     * 
     */
    message?: string;
}

/**
 * Check if a given object implements the TextMessage interface.
 */
export function instanceOfTextMessage(value: object): value is TextMessage {
    return true;
}

export function TextMessageFromJSON(json: any): TextMessage {
    return TextMessageFromJSONTyped(json, false);
}

export function TextMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function TextMessageToJSON(json: any): TextMessage {
    return TextMessageToJSONTyped(json, false);
}

export function TextMessageToJSONTyped(value?: TextMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

